import { DefaultFetchService } from "app/services/fetchService";
import DurationService from "app/services/DurationService";
import { allTrackers } from "app/services/track/track";
import { isIncludeSubDomains } from "app/UtilitiesAndConstants/UtilityFunctions/common";

export const getExelLink = (params) => {
    const ENDPOINT = "widgetApi/WebDemographics/WebDemographicsCombined/Excel";
    const { duration, key: keys, webSource, country, isWWW } = params;
    const { from, to, isWindow } = DurationService.getDurationData(duration).forAPI;
    const fetcherService = DefaultFetchService.getInstance();
    const includeSubDomains = isIncludeSubDomains(isWWW);
    const queryParams = fetcherService.requestParams({
        keys,
        webSource,
        from,
        to,
        isWindow,
        country,
        includeSubDomains,
    });
    const excelLink = `${ENDPOINT}?${queryParams}`;
    return excelLink;
};

export const getExcelDownloadTracking = (metric: "Gender" | "Age") => () => {
    allTrackers.trackEvent("Download", "submit-ok", `Excel/Demographics/${metric}`);
};
